import React, { useEffect, useState } from "react";
import SelectErp from "./SelectErp";

// Campo obrigatório (empresa_cnpj, (setValue ou onChange(e)) e value)
const SelectConsultaErp = ({
  label,
  // Faz a consulta na API
  finder,
  setValue,
  // Caso a pessoa mande um setValue, mas não mande um onChange
  onChange = (value) => {
    setValue(value);
  },
  // Toda vez que um desses campos for alterado, o campo será refeito
  onChangeUseEffect = [],
  itemVazio = null,
  variant = "standard",
  ...props
}) => {
  const [loading, setLoading] = useState(true);
  const [optionsList, setOptionsList] = useState([]);

  // Carrega todos os grupos de produtos pelo serviço
  useEffect(() => {
    setLoading(true);
    (async () => {
      const result = await finder();
      if (result && result.success && result.data) {
        // Se um item vazio for adicionado, ele será incluido como primeiro item da lista
        itemVazio
          ? setOptionsList([itemVazio, ...result.data])
          : setOptionsList([...result.data]);
      } else setOptionsList([]);
      setLoading(false);
    })();
    // eslint-disable-next-line
  }, [...onChangeUseEffect, finder, itemVazio]);

  return (
    <SelectErp
      {...props}
      loading={loading}
      label={label}
      variant={variant}
      onChange={(e) => onChange(e)}
      key={props.key ? props.key : "Select_" + label}
      optionsList={optionsList}
    />
  );
};

export default SelectConsultaErp;
